module.exports = __webpack_public_path__ + "img/competencies_rd_swiper_02.4ec57657.jpg";